import { env } from '$env/dynamic/public';

export const variables = {
	basePathApi: env.PUBLIC_BASE_PATH_API,
	BaseHost: env.PUBLIC_BASE_HOST,
	CDEK_API_KEY: env.PUBLIC_CDEK_API_KEY,
	TERMINALKEY: env.PUBLIC_TERMINALKEY,
	PROTOKOL: env.PUBLIC_PROTOKOL,
	BASE_DOMEN: env.PUBLIC_BASE_DOMEN,
	RedirectUriYandex: env.PUBLIC_REDIRECT_URI_YANDEX,
	ResdirectGoogleAuth: env.PUBLIC_REDIRECT_URI_GOOGLE,
	GOOGLE_ID_CLIENT: env.PUBLIC_GOOGLE_ID_CLIENT,
	GOOGLE_SECRET_CLIENT: env.PUBLIC_GOOGLE_SECRET_CLIENT,
	DOMAIN: env.PUBLIC_DOMAIN,
	KEY_YANDEX_SEARCH: env.PUBLIC_KEY_YANDEX_SEARCH,
	NotificationURL: env.PUBLIC_NotificationURL
};
